<template>
  <div>
    <template>
      <v-container fill-height>
        <v-layout justify-center align-center>
          <v-flex shrink>
            <span> Welcome To My   Wallet Watcher </span>
          </v-flex>
        </v-layout>
      </v-container>
    </template>

  </div>
</template>

<script>
  import { auth } from '../../auth/index';


  export default {
    data() {
      return {

      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardHome.vue